import { api } from "../api/requests";

// Get All Transactions
export async function getAllTransactions(pageNumber?: number, pageSize?: number, offset?: number, paged?: boolean, search?: string, sort?: { sorted: boolean, unsorted: boolean }, unpaged?: boolean): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/transactions?pageNumber=${pageNumber}&pageSize=${pageSize}${offset ? `&offset=${offset}` : ''}${paged ? `&paged=${paged}` : ''}${search ? `&search=${search}` : ''}${sort ? `&sort.sorted=${sort?.sorted}&sort.unsorted=${sort?.unsorted}` : ''}${unpaged ? `&unpaged=${unpaged}` : ''}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}


// Create a new transaction
export async function createTransaction(transaction: any): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/transactions`, transaction)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}


// GET
// Get transaction by id
export async function getTransactionById(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/transactions/${id}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Update an existing transaction
export async function updateTransaction(id: string, transaction: any): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/transactions/${id}`, transaction)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Delete a transaction
export async function deleteTransaction(id: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.delete(`admin/transactions/${id}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Update transaction status
export async function updateTransactionStatus(id: string, status: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.patch(`admin/transactions/${id}/status`, { status })
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Find transactions by company
export async function getTransactionsByCompany(companyId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/transactions/company/${companyId}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Find transactions by date range
export async function getTransactionsByDateRange(startDate: string, endDate: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/transactions/date-range?startDate=${startDate}&endDate=${endDate}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get transaction by reference
export async function getTransactionByReference(reference: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/transactions/reference/${reference}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get transaction statistics
export async function getTransactionStatistics(): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/transactions/statistics`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Find transactions by status
export async function getTransactionsByStatus(status: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/transactions/status/${status}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Find transactions by type
export async function getTransactionsByType(type: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/transactions/type/${type}`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}